import * as Types from '../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RoleRowFragment = { __typename?: 'CustomRole', id: string, name: string, description?: string | null, grants: { __typename?: 'GrantsConnection', nodes: Array<{ __typename?: 'Grant', id: string, groupId: string, organisationGroup?: { __typename?: 'Group', id: string, name: string } | null }> } };

export type RolesQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.CustomRolesOrderBy> | Types.CustomRolesOrderBy;
}>;


export type RolesQuery = { __typename?: 'Query', customRoles?: { __typename?: 'CustomRolesConnection', nodes: Array<{ __typename?: 'CustomRole', id: string, name: string, description?: string | null, grants: { __typename?: 'GrantsConnection', nodes: Array<{ __typename?: 'Grant', id: string, groupId: string, organisationGroup?: { __typename?: 'Group', id: string, name: string } | null }> } }> } | null };

export type RemoveCustomRoleMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type RemoveCustomRoleMutation = { __typename?: 'Mutation', removeCustomRoleMutation?: { __typename?: 'DeleteRoleResponse', success?: boolean | null } | null };

export const RoleRowFragmentDoc = gql`
    fragment RoleRow on CustomRole {
  id
  name
  description
  grants: grantsByOrganisationIdAndRoleId {
    nodes {
      id
      groupId
      organisationGroup {
        id
        name
      }
    }
  }
}
    `;
export const RolesDocument = gql`
    query Roles($organisationId: String!, $orderBy: [CustomRolesOrderBy!]! = [NAME_ASC]) {
  customRoles(condition: {organisationId: $organisationId}, orderBy: $orderBy) {
    nodes {
      id
      ...RoleRow
    }
  }
}
    ${RoleRowFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRolesQuery(baseOptions: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables> & ({ variables: RolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export function useRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesSuspenseQueryHookResult = ReturnType<typeof useRolesSuspenseQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const RemoveCustomRoleDocument = gql`
    mutation RemoveCustomRole($id: String!) {
  removeCustomRoleMutation(id: $id) {
    success
  }
}
    `;

/**
 * __useRemoveCustomRoleMutation__
 *
 * To run a mutation, you first call `useRemoveCustomRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomRoleMutation, { data, loading, error }] = useRemoveCustomRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCustomRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomRoleMutation, RemoveCustomRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomRoleMutation, RemoveCustomRoleMutationVariables>(RemoveCustomRoleDocument, options);
      }
export type RemoveCustomRoleMutationHookResult = ReturnType<typeof useRemoveCustomRoleMutation>;
export type RemoveCustomRoleMutationResult = Apollo.MutationResult<RemoveCustomRoleMutation>;
export type RemoveCustomRoleMutationOptions = Apollo.BaseMutationOptions<RemoveCustomRoleMutation, RemoveCustomRoleMutationVariables>;